<div class="fui-layout-container">
  <fui-layout-header [breadcrumbs]="breadcrumbs" headingText="fui-header.account" description="newdash.account_description"></fui-layout-header>
  <div class="fui-layout-pad-content">
    <div class="fui-content-filter mobile-only">
      <div class="d-flex align-items-center flex-wrap">
        <button class="text-nowrap m-y-5 refine-btn-mobile" (click)="appService.showModal(sidebarFilterModal, { size: 'lg' })">
          <fa-icon icon="bars"></fa-icon>
          Show Sections
        </button>
      </div>
    </div>
    <hr />
    <div class="fui-sidebar-content-container">
      <div class="fui-sidebar-filter skinnier sticky">
        <ng-container *ngTemplateOutlet="filterContent"></ng-container>
      </div>
      <div class="m-y-30 w-full">
        <ng-container *ngTemplateOutlet="mainContent"></ng-container>
      </div>
    </div>
  </div>
  <div class="m-t-100 p-b-50">
    <fui-footer></fui-footer>
  </div>
</div>

<ng-template #filterContent>
  <ul>
    <li class="fui-primary-category" [class.selected]="displayedSection == 'general'" [class.active]="displayedSection == 'general'">
      <a
        class="primary-option"
        href="javascript:void(0);"
        (keyup.enter)="appService.mobileMenuShown = false; changeCategory('general')"
        (keyup.space)="appService.mobileMenuShown = false; changeCategory('general')"
        (click)="appService.mobileMenuShown = false; changeCategory('general')"
      >
        {{ "general.profile" | translate }}
      </a>
    </li>
    <li class="fui-primary-category" [class.selected]="displayedSection == 'orders'" [class.active]="displayedSection == 'orders'">
      <a
        class="primary-option"
        href="javascript:void(0);"
        (keyup.enter)="appService.mobileMenuShown = false; changeCategory('orders')"
        (keyup.space)="appService.mobileMenuShown = false; changeCategory('orders')"
        (click)="appService.mobileMenuShown = false; changeCategory('orders')"
      >
        {{ "header.nav.orders" | translate }}
      </a>
    </li>
    <li class="fui-primary-category">
      <a
        class="primary-option"
        href="javascript:void(0);"
        (keyup.enter)="appService.mobileMenuShown = false; changeCategory(appService.app == 'fender' ? 'play_plan' : 'plan')"
        (keyup.space)="appService.mobileMenuShown = false; changeCategory(appService.app == 'fender' ? 'play_plan' : 'plan')"
        (click)="appService.mobileMenuShown = false; changeCategory(appService.app == 'fender' ? 'play_plan' : 'plan')"
      >
        Subscriptions & Billing
      </a>
      <ul class="fui-secondary-categories">
        <li class="fui-secondary-category" [class.selected]="displayedSection == 'play_plan'">
          <a (keyup.enter)="changeCategory('play_plan')" (keyup.space)="changeCategory('play_plan')" (click)="changeCategory('play_plan')">Fender Play</a>
        </li>

        <li class="fui-secondary-category" [class.selected]="displayedSection == 'plan'">
          <a (keyup.enter)="changeCategory('plan')" (keyup.space)="changeCategory('plan')" (click)="changeCategory('plan')">{{ env.studioOnePlusBrandName }}</a>
        </li>
      </ul>
    </li>

    @if (userService.user.country != "JP" && userService.user.language_code != "jp") {
      <li class="fui-primary-category" [class.selected]="displayedSection == 'gift-cards'" [class.active]="displayedSection == 'gift-cards'">
        <a
          class="primary-option"
          href="javascript:void(0);"
          (keyup.enter)="appService.mobileMenuShown = false; changeCategory('gift-cards')"
          (keyup.space)="appService.mobileMenuShown = false; changeCategory('gift-cards')"
          (click)="appService.mobileMenuShown = false; changeCategory('gift-cards')"
        >
          {{ "account.gift_cards" | translate }}
        </a>
      </li>
    }

    <li class="fui-primary-category">
      <a
        class="primary-option"
        href="javascript:void(0);"
        (keyup.enter)="appService.mobileMenuShown = false; changeCategory(appService.app == 'fender' ? 'communication_preferences' : 'account_notifications')"
        (keyup.space)="appService.mobileMenuShown = false; changeCategory(appService.app == 'fender' ? 'communication_preferences' : 'account_notifications')"
        (click)="appService.mobileMenuShown = false; changeCategory(appService.app == 'fender' ? 'communication_preferences' : 'account_notifications')"
      >
        {{ "account.account_settings" | translate }}
      </a>
      <ul class="fui-secondary-categories">
        <li class="fui-secondary-category" [class.selected]="displayedSection == 'communication_preferences'">
          <a (keyup.enter)="changeCategory('communication_preferences')" (keyup.space)="changeCategory('communication_preferences')" (click)="changeCategory('communication_preferences')">
            {{ "account.communication_preferences" | translate }}
          </a>
        </li>
        <li class="fui-secondary-category" [class.selected]="displayedSection == 'account_notifications'">
          <a (keyup.enter)="changeCategory('account_notifications')" (keyup.space)="changeCategory('account_notifications')" (click)="changeCategory('account_notifications')">
            {{ "account.account_notifications" | translate }}
          </a>
        </li>
      </ul>
    </li>
    <li class="fui-primary-category">
      <a
        class="primary-option"
        href="javascript:void(0);"
        (keyup.enter)="appService.mobileMenuShown = false; changeCategory('showcases')"
        (keyup.space)="appService.mobileMenuShown = false; changeCategory('showcases')"
        (click)="appService.mobileMenuShown = false; changeCategory('showcases')"
      >
        {{ env.studioOnePlusBrandName }} {{ "general.settings" | translate }}
      </a>
      <ul class="fui-secondary-categories">
        <li class="fui-secondary-category" [class.selected]="displayedSection == 'showcases'">
          <a (keyup.enter)="changeCategory('showcases')" (keyup.space)="changeCategory('showcases')" (click)="changeCategory('showcases')">{{ "com.showcases" | translate }}</a>
        </li>
        <li class="fui-secondary-category" [class.selected]="displayedSection == 'storage'">
          <a (keyup.enter)="changeCategory('storage')" (keyup.space)="changeCategory('storage')" (click)="changeCategory('storage')">Storage</a>
        </li>
      </ul>
    </li>
  </ul>
</ng-template>

<ng-template #mainContent>
  @if (displayedSection == "general") {
    <myp-account-general></myp-account-general>
  }
  @if (displayedSection == "showcases") {
    <myp-account-showcases></myp-account-showcases>
  }
  @if (displayedSection == "orders") {
    <myp-account-orders></myp-account-orders>
  }
  @if (displayedSection == "gift-cards") {
    <myp-account-gift-cards></myp-account-gift-cards>
  }
  @if ((displayedSection == "plan" || displayedSection == "play_plan") && !userService.subDetails) {
    <myp-skeleton-loader type="line" width="20%" height="30px" extraContainerClass="m-b-20"></myp-skeleton-loader>
    <myp-skeleton-loader [number]="12" extraContainerClass="m-y-10" [useRandomWidth]="true" type="line"></myp-skeleton-loader>
  }
  @if (
    (displayedSection == "plan" && userService.subDetails && !userService.subDetails.active) ||
    (displayedSection == "plan" && userService.subDetails?.active && (userService.subDetails?.subscription.provider === "stripe" || userService.subDetails?.subscription.provider === "presonus"))
  ) {
    <myp-account-plan-stripe></myp-account-plan-stripe>
  }
  @if (displayedSection == "plan" && userService.subDetails?.subscription?.provider === "recharge") {
    <myp-account-plan-generic></myp-account-plan-generic>
  }
  @if (displayedSection == "play_plan") {
    <myp-account-play-plan></myp-account-play-plan>
  }
  @if (
    (displayedSection == "plan" && userService.subDetails && !userService.subDetails.active) ||
    (displayedSection == "plan" && (userService.subDetails?.subscription.provider === "stripe" || userService.subDetails?.subscription.provider === "presonus"))
  ) {}

  @if (displayedSection == "communication_preferences") {
    <myp-account-notifications></myp-account-notifications>
  }
  @if (displayedSection == "account_notifications") {
    <myp-notification-preferences></myp-notification-preferences>
  }
  @if (displayedSection == "collaboration") {
    <myp-account-collaboration></myp-account-collaboration>
  }
  @if (displayedSection == "storage") {
    <myp-account-file-management></myp-account-file-management>
  }
</ng-template>

<ng-template #sidebarFilterModal let-modal>
  <div class="modal-body fui-sidebar-filter-mobile">
    <ng-container *ngTemplateOutlet="filterContent"></ng-container>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary" (click)="modal.close()">Done</button>
  </div>
</ng-template>
